import { makeEnvironmentProviders } from '@angular/core';
import { TELE_ENGINE_ENVIRONMENT } from '../tokens/tele-engine-environment.token';
import { TeleEngineEnvironment } from '../types/tele-engine-environment';

export const provideTeleEngine = (environment: TeleEngineEnvironment) =>
  makeEnvironmentProviders([{ provide: TELE_ENGINE_ENVIRONMENT, useValue: environment }]);
